import { Button, Typography } from "@mui/material";
import PageviewIcon from "@mui/icons-material/Pageview";
import { buttonColors, colors } from "../../utility/types/constant";

interface ViewSendAddRequestBtnProps {
  onClick: () => void;
}

const ViewSendAddRequestBtn = (props: ViewSendAddRequestBtnProps) => {
  const { onClick } = props;

  return (
    <Button
      onClick={onClick}
      variant="outlined"
      sx={{
        borderColor: buttonColors.mainPrimary,
        color: colors.mainPrimary,
      }}
      startIcon={<PageviewIcon />}
    >
      <Typography
        variant="subtitle2"
        sx={{
          color: colors.darkGrey,
        }}
      >
        Request
      </Typography>{" "}
    </Button>
  );
};

export default ViewSendAddRequestBtn;
